import { forwardRef } from 'react';
import { Box as MuiBox } from '@mui/material';
import { mergeSxStyle } from '../../common/mergeSxStyle';

/**
 * It is a container.
 */
import { jsx as _jsx } from "react/jsx-runtime";
export const Box = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    component,
    sx,
    children,
    ...rest
  } = props;
  const style = mergeSxStyle({}, sx);
  return /*#__PURE__*/_jsx(MuiBox, {
    component: component,
    sx: style,
    ...rest,
    ref: ref,
    children: children
  });
});
Box.displayName = 'Box';